import React, { Component } from 'react';
import GiftWhiteSvg from '../../assets/icons/gift_white.svg';

class HLBRewardsTag extends Component {
  render() {
    return (
      <div className="hlb-campaign-rewards-tag">
        <img src={GiftWhiteSvg} width={12} alt="Gift Icon" />
        <span>MHub Rewards</span>
      </div>
    );
  }
}

export default HLBRewardsTag;



// WEBPACK FOOTER //
// ./src/components/HLBCampaign/HLBRewardsTag.jsx